<form [formGroup]="form" class="project-details__form" appDirtyCheck>
  <section class="project-details__section">
    <h2 class="mat-body-large">
      {{ "Systemdaten" | translate: "paragraph-system-data" }}
    </h2>

    @if (baseDataGroup) {
      <div [formGroup]="form" class="project-details__fields">
        <mat-form-field ogsDisabled class="project-details__field">
          <mat-label>{{ "Projektnummer" | translate: "input-project-number" }}</mat-label>
          <input type="text" matInput formControlName="number" />
        </mat-form-field>

        <mat-form-field class="project-details__field">
          <mat-label>{{ "Projektname" | translate: "input-project-name" }}</mat-label>
          <input type="text" matInput formControlName="name" />
          @if (form.controls.name.hasError(FORM_FIELD_ERRORS.required)) {
            <mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
          }
        </mat-form-field>

        <div [formGroup]="baseDataGroup" class="project-details__fields">
          <mat-form-field class="project-details__field">
            <mat-label>{{ "Projektkurzname" | translate: "input-project-short-name" }}</mat-label>
            <input type="text" matInput formControlName="shortName" />
          </mat-form-field>

          <mat-form-field class="project-details__field">
            <mat-label>{{ "Kostenstelle" | translate: "input-cost-center" }}</mat-label>
            <input type="text" matInput formControlName="costCenterNumber" />
           @if (form.controls.baseData.controls.costCenterNumber.hasError(FORM_FIELD_ERRORS.required)) {
												<mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
											}
          </mat-form-field>
										<mat-form-field matAutocompleteOrigin #formField="matAutocompleteOrigin">
											<mat-label>{{ "Region" | translate: "input-region" }}</mat-label>
											<app-base-select
											[connectedFormField]="formField"
											formControlName="costCenterRegion"
											[getItems]="getCostCenterRegions"
											valueField="localizedName"
											identifierField="number"/>
           @if (form.controls.baseData.controls.costCenterRegion.hasError(FORM_FIELD_ERRORS.required)) {
												<mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
											}
										</mat-form-field>

          <mat-form-field ogsDisabled class="project-details__field">
            <mat-label>{{ "Bauherr / in" | translate: "input-building-owner" }}</mat-label>
            <input type="text" matInput [value]="baseDataGroup.get('buildingOwner')?.value || ''" disabled />
          </mat-form-field>
        </div>
      </div>
    }
  </section>

  <section class="project-details__section">
    <h2 class="mat-body-large">
      {{ "Adresse" | translate: "paragraph-address" }}
    </h2>

    <div class="project-details__fields">
					@let addressGroup = form.controls.address;
      @if (addressGroup) {
        <div [formGroup]="addressGroup" class="project-details__fields">
          @let streets = form.controls.address.controls.streets;

          <app-dynamic-form-field-list [maxItems]="2" [formArray]="streets" [createFormControl]="createAdditionalStreetControl">
            <ng-template ogsItem let-index="index">
              @if (index === 0) {
                <mat-form-field formArrayName="streets">
                  <mat-label>{{ "Straße" | translate : "input-street" }}</mat-label>
                  <input matInput [formControlName]="index" />
                  @if (streets.at(0).hasError(FORM_FIELD_ERRORS.required)) {
                    <mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
                  }
                </mat-form-field>
              } @else {
                <mat-form-field formArrayName="streets">
                  <mat-label>{{ "Straße 2" | translate : "input-street-2" }}</mat-label>
                  <input matInput [formControlName]="index" />
                </mat-form-field>
              }
            </ng-template>
          </app-dynamic-form-field-list>

          <mat-form-field class="project-details__field">
            <mat-label>{{ "Postleitzahl" | translate: "input-zip-code" }}</mat-label>
            <input type="text" matInput formControlName="zipCode" />
            @if (addressGroup.controls.zipCode.hasError(FORM_FIELD_ERRORS.required)) {
              <mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="project-details__field">
            <mat-label>{{ "Ort" | translate: "input-city" }}</mat-label>
            <input type="text" matInput formControlName="city" />
            @if (addressGroup.controls.city.hasError(FORM_FIELD_ERRORS.required)) {
              <mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
            }
          </mat-form-field>

            <mat-form-field matAutocompleteOrigin #formField="matAutocompleteOrigin">
              <mat-label>{{ "Bundesland" | translate : "input-federal-state" }}</mat-label>
              <app-region-select
                [countryIsoCodeTwo]="selectedCountry()?.isoCodeTwo ?? null"
                [connectedFormField]="formField"
                formControlName="region"
              />
            </mat-form-field>

          @if (addressGroup.get('country')) {
            <mat-form-field matAutocompleteOrigin #formField="matAutocompleteOrigin">
              <mat-label>{{ "Land" | translate : "input-country" }}</mat-label>
              <app-country-select [connectedFormField]="formField" formControlName="country" />
              @if (addressGroup.controls.country.hasError(FORM_FIELD_ERRORS.required)) {
                <mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
              }
            </mat-form-field>
          }
        </div>
      }

      @let emails = form.controls.baseData.controls.emails;

      <div [formGroup]="baseDataGroup">
        <app-dynamic-form-field-list
          [maxItems]="5"
          [formArray]="emails"
          [createFormControl]="createAdditionalEmailControl"
        >
          <ng-template ogsItem let-index="index">
            <mat-form-field>
              <mat-label>
                {{
                  ("Email" | translate : "input-email") +
                    " " +
                    (index === 0 ? "" : (index + 1))
                }}
              </mat-label>
              <input matInput [formControl]="emails.at(index)" />
              @if (emails.at(index).hasError(FORM_FIELD_ERRORS.email) && !emails.at(index).hasError(FORM_FIELD_ERRORS.required)) {
                <mat-error>{{ "Bitte geben Sie ein gültiges E-Mail-Format ein." | translate : "input-error-invalid-email-format" }}</mat-error>
              } @else if (emails.at(index).hasError(FORM_FIELD_ERRORS.required)) {
                <mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
              }
            </mat-form-field>
          </ng-template>
        </app-dynamic-form-field-list>
      </div>
    </div>
  </section>

  <section class="project-details__section project-status">
			<div class="project-details__section">
				<h2 class="mat-body-large">
				{{ "Projektstatus" | translate: "label-project-status" }}
				</h2>
				<mat-form-field>
					<mat-label>{{"Status" | translate : "input-status"}}</mat-label>
					<mat-select
					 formControlName="status" 
					 panelClass="select__panel--surface">
						<mat-option [value]="PROJECT_STATUS_TYPES.active">
							{{"Aktiv" | translate : "status.active" : "project"}}
						</mat-option>
							<mat-option [value]="PROJECT_STATUS_TYPES.inactive">
       {{"Inaktiv" | translate : "status.inactive" : "project"}}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="project-details__section">
				<h2 class="mat-body-large">
					{{ "Projektstart und geplantes Ende" | translate: "paragraph-project-end-start" }}
			</h2>
			<div class="project-details__fields">
					<div class="project-details__timespan">
							<mat-form-field class="project-details__field">
									<mat-label>{{ "Start" | translate:'input-start-date' }}</mat-label>
									<input appLocalizedDatepicker matInput [matDatepicker]="startPicker" formControlName="plannedStart" />
									<mat-datepicker-toggle matSuffix [for]="startPicker" />
									<mat-datepicker #startPicker />
									@if (form.controls.plannedStart.hasError(FORM_FIELD_ERRORS.required)) {
											<mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
									}
							</mat-form-field>

							<mat-form-field class="project-details__field">
									<mat-label>{{ "Ende" | translate:'input-end-date' }}</mat-label>
									<input appLocalizedDatepicker matInput [matDatepicker]="endPicker" formControlName="plannedEnd" />
									<mat-datepicker-toggle matSuffix [for]="endPicker" />
									<mat-datepicker #endPicker />
									@if (form.controls.plannedEnd.hasError(FORM_FIELD_ERRORS.required)) {
											<mat-error>{{ "Pflichtfelder müssen ausgefüllt werden." | translate : "input-error-required-fields" }}</mat-error>
									}
							</mat-form-field>
					</div>

					@let plannedStart = form.controls.plannedStart.value;
					@let plannedEnd = form.controls.plannedEnd.value;

					@if (plannedStart && plannedEnd) {
							<div class="project-details__duration">
									<span class="mat-body-medium">
											{{ "Projektdauer" | translate: "label-project-duration" }}:
									</span>
									<time
											app-duration
											class="project-details__duration-value"
											[startDate]="plannedStart"
											[endDate]="plannedEnd"
									></time>
							</div>
					}

					<div class="project-details__image">
							<p class="project-details__section-title mat-body-large">
									{{ "Foto" | translate: "paragraph-image" }}
							</p>
							<p class="project-details__hint mat-body-small">
									{{ "Hier können Sie ein Profilbild für das\nProjekt hochladen." | translate: "paragraph-image-description" }}
							</p>
							<app-image-upload formControlName="image" />
					</div>
			</div>
		</div>
  </section>
</form>

<app-form-footer
  (save)="saveChanges()"
  (discard)="discardChanges()"
/>
